// (function () {
//     'use strict';

//     angular.module("imApp").factory("factsService", [function () {
//         let service = {};

//         return service;
//     }]);
// })();
